import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import { Privileges } from '../../../util/PrivilegeConstants';
import { updateScheduleStatus } from './ScheduleCURD';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import { debounce } from 'lodash';
import { ScheduleStatus } from '../../../util/CalendarUtil';
import { isUpdateEntireSeries, recurrenceIdOf } from './schedulerForm';

export const scheduleStatusUpdateFromEditor = (args, clubId, status) => ({
    id: args?.Id,
    clubId,
    recurrenceId: recurrenceIdOf(args),
    isUpdateEntireSeries: isUpdateEntireSeries(args),
    status,
});

const EditorFooterTemplate = ({ args, privileges, selectedClub, scheduleRef, setIsRefresh, onSave, onClose }) => {
    const dispatch = useDispatch()
    const entireSeries = isUpdateEntireSeries(args);
    const debouncedRefresh = debounce(() => {
        setIsRefresh(true);
        if (selectedClub.isPlanRequired) {
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        }
    }, 420);

    const handleUpdateScheduleStatus = async (status) => { 
        try {
            const obj = scheduleStatusUpdateFromEditor(args, selectedClub.clubId, status);
            await updateScheduleStatus(obj);
            scheduleRef.current.closeEditor();
            dialogObj.hide();
            debouncedRefresh();
        } catch (e) {
            scheduleRef.current.closeEditor();
            console.error(e);

        }
    }
    let items = [
        {
            text: 'Delete',
        },
        {
            text: 'Cancel',
        }
    ];

    let dialogObj;

    function onSelect(selection) {
        if (selection.item.text === 'Delete') {
            dialogObj = DialogUtility.confirm({
                title: 'Delete Schedule',
                content: entireSeries
                    ? 'This deletes every event in this series.'
                    : 'This deletes only this event. Other events in the series stay.',
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: {click: ()=>handleUpdateScheduleStatus(ScheduleStatus.DELETE)},
                cancelButton: {
                    click: () => {
                        dialogObj.hide();
                    }
                }
            });
        }
        if (selection.item.text === 'Cancel') {
            dialogObj = DialogUtility.confirm({
                title: 'Cancel Schedule',
                content: entireSeries
                    ? 'This cancels every event in this series.'
                    : 'This cancels only this event. Other events in the series stay.',
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: {click: ()=>handleUpdateScheduleStatus(ScheduleStatus.CANCELED)},
                cancelButton: {
                    click: () => {
                        dialogObj.hide();
                    }
                }
            });
        }
    }

    return (
        <div id="event-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div id="left-button">
                {(args?.Id && privileges?.RESERVATION?.includes(Privileges.DELETE)) &&
                    <DropDownButtonComponent id="element" items={items} select={onSelect}>
                        More Actions</DropDownButtonComponent>
                }
            </div>
            <div id="right-button">
                {(!args?.Id && privileges?.RESERVATION?.includes(Privileges.CREATE) || (args?.Id && privileges?.RESERVATION?.includes(Privileges.MODIFY))) &&
                    <button id="Save" className="e-control e-btn e-primary" data-ripple="true" type="button" onClick={onSave}>
                        Save
                    </button>}
                <button id="Cancel" className="e-control e-btn e-secondary" data-ripple="true" type="button" onClick={() => (onClose || scheduleRef.current.closeEditor)()}>
                    Cancel
                </button>
            </div>
        </div>
    );
}

export default EditorFooterTemplate